export default __webpack_public_path__ + "static/media/Gif_GratisER.88704569.gif";